import { Box } from '@mui/material';
import { DynamicIcon } from 'src/components';
import {
  DATA_CONVERSATION_FRIENDLY_ID,
  DATA_ENTITY_TYPE,
  DATA_PARTNER_PREFIX,
} from 'src/components/TextWithUI/const';
import { UIReplacerName } from 'src/components/TextWithUI/types';

export const ChatConversationLink = ({
  themeVariables,
  conversationFriendlyId,
  conversationSubject,
  partnerPrefix,
}: {
  conversationFriendlyId: string;
  conversationSubject: string;
  partnerPrefix: string;
  themeVariables: {
    chipIconColor: string;
    chipBorderRadius: string;
    chipBackgroundColor: string;
  };
}) => {
  const fullText = `${conversationFriendlyId}${conversationSubject ? `: ${conversationSubject}` : ''}`;

  const dataAttributes = {
    [DATA_ENTITY_TYPE]: UIReplacerName.ConversationLink,
    [DATA_CONVERSATION_FRIENDLY_ID]: conversationFriendlyId,
    [DATA_PARTNER_PREFIX]: partnerPrefix,
  };

  return (
    <Box
      {...dataAttributes}
      component="span"
      style={{
        cursor: 'pointer',
        position: 'relative',
        backgroundColor: themeVariables.chipBackgroundColor,
        borderRadius: themeVariables.chipBorderRadius,
        padding: '0.1rem 0.25rem',
        transition:
          'background-color 300ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      <DynamicIcon
        name="chat_bubble"
        component="span"
        style={{ position: 'absolute', fontSize: '18px', color: themeVariables.chipIconColor }}
      />
      <Box
        component="span"
        style={{
          fontSize: 'inherit',
          fontFamily: 'inherit',
          lineHeight: 'inherit',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          marginLeft: '1.5rem',
        }}
      >
        {fullText}
      </Box>
    </Box>
  );
};
